import { composeInitialState } from '@opengov/compose-app';
import { IEntity } from '@opengov/api-deprecated';

import { Entity } from '../entity/records';
import { composeStateMachine } from '../module';
import { RequestStatus } from '../transport';
import { ISession } from '../types';

import { Session } from './records';

export const initialState = composeInitialState({
  loadingSession: RequestStatus(),
  session: Session()
});

export const sessionState = composeStateMachine('session', initialState, compose => ({
  fetchSession: compose.payloadlessAction(state => state.set('loadingSession', RequestStatus({ active: true }))),

  fetchSessionSuccess: compose.action((state, session: ISession) =>
    state.set('session', Session(session)).set('loadingSession', RequestStatus())
  ),

  initializeAnonymousSession: compose.action((state, entity: IEntity) =>
    state.set('session', Session({ entity: Entity(entity) })).set('loadingSession', RequestStatus())
  ),

  fetchSessionError: compose.action((state, error: any) =>
    state.set('loadingSession', RequestStatus({ active: false, error }))
  )
}));

export const {
  actions: sessionActions,
  actionCreators: sessionActionCreators,
  reducer: sessionReducer,
  selector: sessionSelector
} = sessionState;
